<template lang="html">
  <div class="single_choice">
    <!-- 卡片 -->
    <div class="answer_card">
      <div class="topic_name">
        <p class="topic_number">
          <span class="this_num">{{singlechoice.seq}}</span>
          <span class="all_num">/</span>
          <span class="all_num">{{allTopic}}</span>
        </p>
        <p class="topic_type">{{singlechoice.type_name}}</p>
      </div>

      <div class="testQuestions_con">
        <!-- 题目 -->
        <div class="testQuestions">
          {{singlechoice.content}}
        </div>
        <!-- 题目中含有图片 -->
        <div class="" v-if="singlechoice.images.length > 0">
          <div class="testQuestions_img" v-if="singlechoice.images.length > 1" @click="toFatherData(singlechoice.images)">
            <img class="allIcon" src="../../../assets/image/exam/allimg.png" alt="">
            <img :src="singlechoice.images[0]" alt="" class="exhibitionImg">
          </div>
          <div class="testQuestions_img" v-else @click="toFatherData(singlechoice.images)">
            <img :src="singlechoice.images" alt="" class="exhibitionImg">
          </div>

          <div class="option_three" v-if="this.singlechoice.choices.length == 3 && this.singlechoice.choices[0].images != ''">
            <div class="option_three_con" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_three_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_three_txt" v-else>
                <p>{{c.option_name}}) </p>
                <p class="optionText">{{c.content}}</p>
              </div>
            </div>
          </div>
          <div class="option_three_2" v-else-if="this.singlechoice.choices.length == 3 && this.singlechoice.choices[0].images == ''">
            <div class="option_three_con_2" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_three_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_three_txt_2" v-else>
                <p>{{c.option_name}}) </p>
                <p class="optionText">{{c.content}}</p>
              </div>
            </div>
          </div>

          <div class="option_four" v-if="singlechoice.choices.length == 4">
            <div class="option_four_con" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_four_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_four_txt" v-else>
                <p>{{c.option_name}}) </p>
                <p class="optionText"> {{c.content}}</p>
              </div>
            </div>
          </div>
        </div>


        <!-- 没图 -->
        <div class="" v-else>
          <div class="option_three" v-if="this.singlechoice.choices.length == 3 && this.singlechoice.choices[0].images != ''">
            <div class="option_three_con" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_three_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_three_txt" v-else>
                <p>{{c.option_name}})</p>
                <p class="optionText">{{c.content}}</p>
              </div>
            </div>
          </div>

          <div class="option_three_2" v-else-if="this.singlechoice.choices.length == 3 && this.singlechoice.choices[0].images == ''">
            <div class="option_three_con_2" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_three_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_three_txt_2" v-else>
                <p>{{c.option_name}}) </p>
                <p class="optionText">{{c.content}}</p>
              </div>
            </div>
          </div>

          <div class="option_four" v-if="singlechoice.choices.length == 4 && this.singlechoice.choices[0].images != ''">
            <div class="option_four_con" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_four_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_four_txt" v-else>
                <p>{{c.option_name}}) </p>
                <p class="optionText"> {{c.content}}</p>
              </div>
            </div>
          </div>

          <div class="option_four_2" v-if="singlechoice.choices.length == 4 && this.singlechoice.choices[0].images == ''">
            <div class="option_four_con_2" v-for="(c, index) in singlechoice.choices" :key="index">
              <div class="option_four_img" v-if="c.images.length != 0">
                <div class="option_content" @click="toFatherData(c.images)">
                  <img :src="c.images" alt="">
                </div>
                <div class="option">
                  {{c.option_name}}
                </div>
              </div>
              <div class="option_four_txt_2" v-else>
                <p>{{c.option_name}})</p>
                <p class="optionText">{{c.content}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 选择 -->
      <div class="select">
        <div class="select_btn">
          <div>
            <img src="../../../assets/image/exam/option_a.png" alt="" v-show="optionA" @click="getRadioVal(singlechoice.choices[0].option_value)">
            <img src="../../../assets/image/exam/optionA.png" alt="" v-show="optiona" @click="recover(singlechoice.choices[0].option_value)">
          </div>
          <div>
            <img src="../../../assets/image/exam/option_b.png" alt="" v-show="optionB" @click="getRadioVal(singlechoice.choices[1].option_value)">
            <img src="../../../assets/image/exam/optionB.png" alt="" v-show="optionb" @click="recover(singlechoice.choices[1].option_value)">
          </div>
          <div>
            <img src="../../../assets/image/exam/option_c.png" alt="" v-show="optionC" @click="getRadioVal(singlechoice.choices[2].option_value)">
            <img src="../../../assets/image/exam/optionC.png" alt="" v-show="optionc" @click="recover(singlechoice.choices[2].option_value)">
          </div>
          <div v-if="singlechoice.choices.length > '3' ">
            <img src="../../../assets/image/exam/option_d.png" alt="" v-show="optionD" @click="getRadioVal(singlechoice.choices[3].option_value)">
            <img src="../../../assets/image/exam/optionD.png" alt="" v-show="optiond" @click="recover(singlechoice.choices[3].option_value)">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


export default {
  props: ['singlechoice', 'allTopic'],
  data(){
    return{
      optionA: true,
      optiona: false,
      optionB: true,
      optionb: false,
      optionC: true,
      optionc: false,
      optionD: true,
      optiond: false,
      picked: [],
    }
  },
  mounted(){
  },
  methods:{
    getRadioVal(num) {
      if(num == "0"){
        this.optionA = false;
        this.optiona = true;
        this.optionB = true;
        this.optionb = false;
        this.optionC = true;
        this.optionc = false;
        this.optionD = true;
        this.optiond = false;
      }else if(num == "1"){
        this.optionA = true;
        this.optiona = false;
        this.optionB = false;
        this.optionb = true;
        this.optionC = true;
        this.optionc = false;
        this.optionD = true;
        this.optiond = false;
      }else if(num == "2"){
        this.optionA = true;
        this.optiona = false;
        this.optionB = true;
        this.optionb = false;
        this.optionC = false;
        this.optionc = true;
        this.optionD = true;
        this.optiond = false;
      }else if(num == "3"){
        this.optionA = true;
        this.optiona = false;
        this.optionB = true;
        this.optionb = false;
        this.optionC = true;
        this.optionc = false;
        this.optionD = false;
        this.optiond = true;
      }
      this.$parent.fatherMethod(this.singlechoice.question_id, [num]);
    },
    recover(num){
      var a = this.picked.indexOf(num);
      if(num == 0){
        this.optionA = true;
        this.optiona = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.singlechoice.question_id, this.picked);
        return this.picked;
      }
      if(num == 1){
        this.optionB = true;
        this.optionb = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.singlechoice.question_id, this.picked);
        return this.picked;
      }
      if(num == 2){
        this.optionC = true;
        this.optionc = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.singlechoice.question_id, this.picked);
        return this.picked;
      }
      if(num == 3){
        this.optionD = true;
        this.optiond = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.singlechoice.question_id, this.picked);
        return this.picked;
      }
    },

    toFatherData(e){
      this.$emit("toFatherData",e);
    }
  }
}
</script>

<style lang="css" scoped>
.answer_card{
  box-sizing: border-box;
  width: 100%;
  height: 56rem;
  background: url("../../../assets/image/exam/code_back.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 7.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
  /* padding-bottom: 9.5rem; */
  position: relative;
}

.topic_name{
  display: flex;
  align-items: center;
}
.topic_number{
  display: flex;
  align-items: center;
}
.this_num{
  font-size: 2.4rem;
  color: #7966CA;
}
.all_num{
  font-size: 1.8rem;
  color: #A6A9BA;
  padding-top: .3rem;
}
.topic_type{
  margin-left: .8rem;
  font-size: 1.6rem;
  color: #7966CA;
}

/* 试题 */
.testQuestions{
  font-size: 1.6rem;
  color: #1D2023;
  margin-top: 1rem;
}
.testQuestions_img{
  display: flex;
  justify-content: center;
  position: relative;
}
.exhibitionImg{
  margin-top: 1.8rem;
  width: 18rem;
  height: 10rem;
  object-fit: cover;
  border-radius: .5rem;
}
.allIcon{
  width: 2.2rem;
  height: 2.2rem;
  position: absolute;
  top: 28px;
  left: 65px;
}

/* 3项 */
.option_three{
  margin-top: 1.8rem;
  display: flex;
  justify-content: space-between;
}
.option_three_con{
  width: 33.3333333333333%;
}
.option_three_img{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

}
.option_three_img img{
  width: 9rem;
  height: 5.5rem;
  object-fit: cover;
  border-radius: .5rem;
}
.option_three_txt{
  display: flex;
  justify-content: flex-start;
  text-align: center;
  margin-top: 2rem;
}

.option_three_2{
  height: 30rem;
  overflow: auto;
}
.option_three_txt_2{
  margin-top: 2rem;
  display: flex
}

/* 有图 */
.option_four{
  margin-top: 1.8rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.option_four_con{
  width: 50%;
}
.option_four_img{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.option_four_img img{
  width: 9rem;
  height: 5.5rem;
  object-fit: cover;
  border-radius: .5rem;
}
.option{
  text-align: center;
}
/* 没有图 */
.option_four_txt{
  display: flex;
  justify-content: flex-start;
  text-align: center;
  margin-top: 2rem;
}
.option_four_txt p{
  padding-right: .5rem;
}

.option_four_2{
	height: 30rem;
  overflow: auto;
}

.option_four_txt_2{
  margin-top: 2rem;
  display: flex
}
.optionText{
	margin-left: 1rem;
}

.select{
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
}
.select_btn{
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;
}
.select_btn img{
  width: 5.1rem;
  margin: 0 1.25rem;
}
</style>
